<div class="modal-header d-flex justify-content-center bg-light">
    <h4 class="modal-title text-center">Confirm bid<div class="modalsubheader">{{'tenders.confirmBid'|cxTranslate}}
        </div>
    </h4>
</div>
<div *ngIf="enableLoader" id="loader"></div>
<div *ngIf="!enableLoader">
    <div class="modal-body bg-light">
        <div>
            <h5 class="strong">{{productInfo.newName?productInfo.newName:productInfo.productName}}</h5>
        </div>
        <div class="d-flex justify-content-between mt-2">
            <div class="small">
                <div class="small text-secondary ">{{ 'tenders.Quantity(DMT)' | cxTranslate
                    }}({{productInfo.displayQuantityUnitDesc}})</div>
                <h6 class="strong" *ngIf="productInfo?.quantity && isQuantityUnrestricted== false">
                    {{productInfo?.quantity |
                    number}}</h6>
                <div class="strong" *ngIf="productInfo?.quantity && isQuantityUnrestricted== true">{{quantityshw |
                    number}}
                </div>
                <h6 class="strong" *ngIf="productInfo?.minimumQuantity && productInfo?.maximumQuantity">{{quantity |
                    number}}</h6>
                <!-- <div class="strong small">{{productInfo?.quantity}}</div> -->
                <!-- <div class="semibold small">130,000 - 190,000</div>-->
            </div>
            <!-- iron ore & coal specific -->
            <div class="small">
                <div class="small text-secondary " *ngIf="product.commodityType== 'CN'">{{'tenders.Deliveryperiod'|
                    cxTranslate}}
                </div>
                <div class="small text-secondary "
                    *ngIf="(product.commodityType=='CC' || product.commodityType=='IO') && product?.arrivalPeriod == 'true'">
                    {{'tenders.ArrivalPeriod'| cxTranslate}}</div>
                <div class="small text-secondary "
                    *ngIf="(product.commodityType=='CC' || product.commodityType=='IO') && product?.arrivalPeriod == 'false'">
                    {{'tenders.LoadPortLaycan'| cxTranslate}}</div>
                    <div class="small text-secondary "
                    *ngIf="(product.commodityType=='CA') && product?.arrivalPeriod == 'false'">
                    {{'tenders.schedule'| cxTranslate}}</div>
                <div class="strong" *ngIf="product?.arrivalPeriod == 'false'">{{productInfo.laycanStartDate |
                    date:"dd/MM/yyyy"}} - {{productInfo.laycanEndDate |
                    date:"dd/MM/yyyy"}}</div>
                <div class="strong" *ngIf="product?.arrivalPeriod == 'true'">{{product.arrivalStartDate |
                    date:"dd/MM/yyyy"}} -
                    {{product.arrivalEndDate |
                    date:"dd/MM/yyyy"}}</div>

            </div>
        </div>
        <div *ngFor="let options of productInfo.pricingOptionsEnum">
            <div class="d-flex justify-content-between mt-2"
                *ngIf=" product.commodityType!= 'CN' && productInfo.childList==undefined">
                <div class="small">
                    <div class="small text-secondary">
                        {{getLabelofConfirmScreen(options,product.commodityType,'ITB')}}</div>
                    <div class="strong">{{getPriceandSymbol(options,price,product.commodityType)}}</div>
                    <div *ngIf="options.pricingBasis">
                        <div *ngIf="options.pricingBasis[0]?.description!=undefined">
                            <div *ngIf="product.commodityType!='CA'" class="small text-secondary ">{{'tenders.Pricingbasis' | cxTranslate}}
                            </div>
                            <div *ngIf="product.commodityType=='CA'" class="small text-secondary ">{{'tenders.OnlyPrice' | cxTranslate}}
                            </div>
                            <div class="small" *ngFor="let Pricingbasis of productInfo.pricingBasis">
                                {{getPricingBasisBasedOnOption(options.pricingOptions,Pricingbasis.description)}} </div>
                        </div>
                    </div>
                    <div *ngIf="options.defaultQuotationPeriod!=''" class="small text-secondary mt-2">Quotation period</div>
                    <div id="67" *ngIf="productInfo.isQuotationPeriodUnrestricted == false && productInfo.isQPMultipleChoicesSelected == false" class="small">
                        {{formatQPDates(productInfo)}}</div>
                    <div *ngIf=" options?.isQPMultipleChoicesSelected == true" class="small">
                        <p id="70" *ngIf="options?.qp[0].description != 'Fixed QP'">{{ options?.qp[0].description}}</p>
                        <p id="71" *ngIf="options?.qp[0].description == 'Fixed QP'">{{getDate(finalQPFromDate)}} - {{getDate(finalQPToDate)}} (both dates inclusive)</p>
                    </div>
                    <div id="75" *ngIf="productInfo.isQuotationPeriodUnrestricted == true  && finalQPFromDate && finalQPToDate && productInfo.isQPMultipleChoicesSelected == false"
                        class="small">{{getDate(finalQPFromDate)}} -
                        {{getDate(finalQPToDate)}} (both dates inclusive)</div>
                        <div *ngIf="(options.premiumIndex!='' && options.premiumIndex!=undefined)" class="form-group mt-2">
                            <div class="small text-secondary ">{{'tenders.Premium' | cxTranslate}}</div>
                            <div class=" small">
                                {{options.premiumIndex}}</div>
                        </div>
                </div>

            </div>
            <div  *ngIf="product.commodityType== 'CN' &&  productInfo.childList==undefined">
                <div class="d-flex justify-content-between mt-2">
                    <div class="small" *ngIf="options.displayTCPrice == true">
                        <div class="small text-secondary  small price-wrap">Your TC (per
                            {{options.tcPriceUnitDesc}})
                        </div>
                        <div class="strong small">USD {{price || '0'}}</div>
                    </div>
                    <div class="small" *ngIf="options.displayRCPrice == true">
                        <div class="small text-secondary wrap">Your RC (per
                            {{options.rcPriceUnitDesc}} of payable Copper)</div>
                        <div class="strong small">USD {{indexPrice|| '0'}}</div>
                    </div>
            </div>
            <div *ngIf="productInfo.baseKOP == 'BA CU'" class="mt-2 small text-secondary">{{'tenders.QuotationPeriodCU'| cxTranslate}} </div>
            <div *ngIf="productInfo.baseKOP == 'BA ZN'" class="mt-2 small text-secondary">{{'tenders.QuotationPeriodZN'| cxTranslate}}</div>
            <div *ngIf="productInfo.baseKOP != 'BA CU' && productInfo.baseKOP != 'BA ZN'" class="mt-2 small text-secondary">{{'tenders.QuotationPeriod'| cxTranslate}}</div>
        <div id="103" *ngIf="productInfo.isQuotationPeriodUnrestricted == false && options.isQPMultipleChoicesSelected == false" class="small">
                {{formatQPDates(productInfo)}}</div>
                <div id="105" *ngIf="options.isQPMultipleChoicesSelected == true" class="small">
                        {{options.qp[0].description}}</div>
            <div id="107" *ngIf="productInfo.isQuotationPeriodUnrestricted == true && options.isQPMultipleChoicesSelected == true && finalQPFromDate && finalQPToDate"
                class="small">{{getDate(finalQPFromDate)}} -
                {{getDate(finalQPToDate)}} (both dates inclusive)</div>
            <div class="d-flex justify-content-between mt-2">
                <div>
                    <div class="small text-secondary mt-2">Terms & conditions</div>
                    <div class="small">
                        {{product.termsAndConditions?product.termsAndConditions.description:'--'}}</div>
                </div>
               
            </div>
            </div>
        </div>


        <div *ngFor="let child of productInfo?.childList;let j=index">
            <div class="d-flex justify-content-between mt-2" *ngFor="let options of child.pricingOptionsEnum">
                <div class="small">
                    <div class="small text-secondary">{{child.productName}} price </div>
                    <div class="strong">{{getPriceandSymbol(options,price)}}</div>
                </div>
            </div>

            <div *ngIf="product.commodityType== 'CN'">
                <div class="small text-secondary mt-2">Terms & conditions</div>
                <div class="strong">{{product.termsAndConditions?product.termsAndConditions.description:'--'}}
                </div>
            </div>
        </div>
        <div class="mt-4" *ngIf="product.commodityType!= 'IO'">
            <p class="mb-2 xs-semibold-font">{{'tenders.BuyerRemarks'|cxTranslate}}</p>
            <textarea class="form-control w-100" maxlength="5000"
                placeholder="{{ 'home.productHeader.bindingTermsPh' | cxTranslate }}"
                [(ngModel)]="biddingTerms"></textarea>
        </div>
    </div>

    <div class="modal-footer bg-light">
        <div class="w-100 text-center">
            <p class="mb-2 xs-semibold-font">{{'tenders.BidValid'| cxTranslate}} :
                {{convertingDateOnly(product.quoteValidity,product.quoteValidityTimeZone)}}
                {{product.quoteValidityTimeZone?product.quoteValidityTimeZone.code:''}}
            </p>
        </div>
        <div class="w-100 text-center">
            <p class="mb-2 xs-semibold-font">{{confirmTxt}}</p>
        </div>
        <div class="w-100">
            <!-- <button class="btn btn-block btn-primary" type="submit" (click)="navigateToQuote(productInfo,quantitySelected)" data-dismiss="modal" [disabled]="startDate == null || disabledBtn || productInfo.priceValue =='' || productInfo.priceValue == 0 || productInfo.priceValue < productInfo.minPrice"> -->
            <button class="btn btn-block btn-primary btn-lg" type="submit" [disabled]="disabledBtn"
                (click)="submitBid()">
                {{ 'home.productHeader.ConfirmBid' | cxTranslate }}
            </button>
            <div class="d-flex justify-content-between mt-2">
                <button class="btn btn-lg btn-light button" type="button" (click)="backToPlacebid()">{{'tenders.Back'|
                    cxTranslate}}</button>
                <button class="btn btn-lg btn-light button" type="button" (click)="activeModal.dismiss('close click')"
                    data-dismiss="modal">{{ 'home.productHeader.Close' | cxTranslate }}</button>
            </div>
        </div>
    </div>
</div>